import React from "react";
import CreateBot from "../../botForm";
import CreateStepper from "../../createBotStepper/index";
import styles from "../../../styles/pages/createBotFinal.module.scss";
import axios from "axios";
import botStyles from "../../../styles/pages/createBot.module.scss";
import { useRouter } from "next/router";
import { useDispatch, connect } from "react-redux";
import {
  currentBotEditedStateAction,
  saveCurrentBot,
} from "./../../../redux/storeBot/actions";
import endpoint from "../../../utility/endpoints";
import { BlobServiceClient } from "@azure/storage-blob";
import SuccessModal from "../../../pages/successModal";
import endpoints from '../../../utility/endpoints';
import BusinessownerModalComp from "../../../pages/successModal";
import Loader from '../../Loader'
import { sessionTimeOutCheck, checkExpiry } from "../../../redux/global/actions.js";
import { bindActionCreators } from "redux";

import { product, family, domain } from "../createBotFormss/gdt_data.js";


const index = (props) => {

  const [successModal, setSuccessModal] = React.useState(false)
  const [businessOwnerModal, setBusinessOwnerModal] = React.useState(false);

  const blobSasUrl =
    "https://newbotstore.blob.core.windows.net/?sv=2020-02-10&ss=bfqt&srt=sco&sp=rwdlacupx&se=2021-04-02T10:26:05Z&st=2021-03-02T02:26:05Z&spr=https&sig=v7MtaG5GbZX7NyzUpshCkd61ouluKHob5uram7ip9eM%3D";
  
    const blobSasUrlNew = endpoints.blobSasUrlNew
    //   "https://newbotstore.blob.core.windows.net/?sv=2020-02-10&ss=bfqt&srt=sco&sp=rwdlacupx&se=2022-04-03T15:11:13Z&st=2021-04-03T07:11:13Z&spr=https&sig=yJGmi7uHf8DAG%2BfT%2FOsKBLFP3URycUiPaPRocqIqSh8%3D";
  const blobServiceClient = new BlobServiceClient(blobSasUrlNew);
  const containerClient = blobServiceClient.getContainerClient("botstorevideo");

  const firstPage = props.data[0].component.content.field_new_bot_details[0];
  const secondPage = props.data[0].component.content.field_new_bot_details[1];
  const thirdPage = props.data[0].component.content.field_new_bot_details[2];
  const fourthPage = props.data[0].component.content.field_new_bot_details[3];

    const [renderFirstBot, setRenderFirstBot] = React.useState(null);

  const router = useRouter();
  const dispatch = useDispatch();

  const isDevEnvironment = endpoints.environment === "dev" ? true : false;

  const productData = product;
  const familyData = family;
  const domainData = domain;

  const leadPlatformData = isDevEnvironment
    ? props.globalData.lead_platform_main_component[3]
    : props.globalData.lead_platform_main_component[1];
  const areaData = isDevEnvironment
    ? props.globalData.lead_platform_main_component[4]
    : props.globalData.lead_platform_main_component[4];
  const subAreaData = isDevEnvironment
    ? props.globalData.lead_platform_main_component[5]
    : props.globalData.lead_platform_main_component[3];

  const clusterData = props.globalData.cluster_main_component[0];
  const mcoData = props.globalData.cluster_main_component[1];
  const countryData = props.globalData.cluster_main_component[2];

  React.useEffect(() => {
    firstPage.field_bot_form_steps.splice(1, 0, productData);
    firstPage.field_bot_form_steps.splice(1, 0, familyData);
    firstPage.field_bot_form_steps.splice(1, 0, domainData);
    firstPage.field_bot_form_steps.splice(4, 0, subAreaData);
    firstPage.field_bot_form_steps.splice(4, 0, areaData);
    firstPage.field_bot_form_steps.splice(4, 0, leadPlatformData);
    firstPage.field_bot_form_steps.splice(7, 0, countryData);
    firstPage.field_bot_form_steps.splice(7, 0, mcoData);
    firstPage.field_bot_form_steps.splice(7, 0, clusterData);
    setRenderFirstBot(true);
  }, []);


  const useMe = {
    1: false,
    2: false,
    3: false,
    4: false,
  };

  const [botPages, setBotPages] = React.useState({
    1: true,
    2: false,
    3: false,
    4: false,
  });

  const [pageNumber, setPageNumber] = React.useState(1);
  const [done, setDone] = React.useState(false);

  const nextBot = (pageNum) => {
    setBotPages({
      ...useMe,
      [pageNum]: true,
    });
    setPageNumber(pageNum);
    window.scrollTo(0,0);
  };

  const saveInfoToRedux = async (state) => {
    if(state.landscape){
      let landscapeId='';
      const landscape=state.landscape
         if(landscape=='Global'){landscapeId='0';}
         if(landscape=='Fusion'){landscapeId='1';}
         if(landscape=='Sirius'){landscapeId='2';}
         if(landscape=='Cordillera'){landscapeId='3';}
         if(landscape=='U2K2'){landscapeId='4';}
           state.landscapeId=landscapeId
    }
    dispatch(saveCurrentBot(state));
  };

  const allDone = async() => {
    // containerClient.deleteBlob(azureFileNames[name]);
    setDone(true);
  //  router.push("/botStore");
  };

  // const mmy = {
  //   mCO: "a",
  //   applications: "a",
  //   dateOfStatusChanged: "2021-12-11",
  //   statusComments: "a",
  //   sopReceivedDate: "2021-12-11",
  //   dataClassification: "a",
  //   numberOfRunsInAMonth: "a",
  //   averageTime: "a",
  //   sopDocument: "a",
  //   UserEmail: "David.Raj@unilever.com",
  //   kFA: true,
  //   kfaTransactional: "yes",
  //   kfaInformational: "no",
  //   kfaIUC: "no",
  // };
  const [botKiID, setBotKiID] = React.useState(null)
  const [ Loading, setLoading ] = React.useState(false)

  React.useEffect( async () => {

    //console.log(props.currentBot, "countryyInEdit")
    // alert("hasudhasuds");
    const BotId=props.currentBot.botID;
    if(props.currentBot.landscapeId==0)
     {
       //console.log("landscpae selected ===>1")
       props.currentBot.landscape="Global"
    }
     if(props.currentBot.landscapeId==1)
     {
       //console.log("landscpae selected ===>2")
       props.currentBot.landscape="Fusion" 
    }
     if(props.currentBot.landscapeId==2)
     {
       //console.log("landscpae selected ===>3")
       props.currentBot.landscape="Sirius"
    }
     if(props.currentBot.landscapeId==3)
     {
       //console.log("landscpae selected ===>4")
       props.currentBot.landscape="Cordillera"
    }
     if(props.currentBot.landscapeId==4)
     {
       //console.log("landscpae selected ===>5")
       props.currentBot.landscape="U2K2"
    }
    if (done == true) {
      setBotKiID(props.currentBot.botExternalId)
       

      if(props.currentBot.landscapeApproval == "Yes"){
        props.currentBot.landscapeApproval = true
      }
      else {
        props.currentBot.landscapeApproval = false
      }
  
      if(props.currentBot.infosecApproval == "Yes"){
        props.currentBot.infosecApproval = true
      }
      else {
        props.currentBot.infosecApproval = false
      }

     // commented for new request ParentBot 24/aug 
     /* 
      if (props.currentBot.requestType == "New Request") {
        props.currentBot.parentBotID = "";
      }*/

      if (props.currentBot.uploadDocumentsState) {
        //console.log(props.currentBot.uploadDocumentsState.deleteDocumentsLater, "oyehoye")
       
        for (let i in props.currentBot.uploadDocumentsState.deleteDocumentsLater) {
        try {
       await containerClient.deleteBlob(
         props.currentBot.uploadDocumentsState.deleteDocumentsLater[i]
       );
       //console.log("oyehoye deleted success")
        //await  containerClient.deleteBlob(props.currentBot.uploadDocumentsState.deleteDocumentsLater[0]);
        }  
        catch (err){
          console.log("error in deleting azure blob",err)
        }
        }
        delete props.currentBot.uploadDocumentsState
      }

      let countryString = "";
      for (let i in props.currentBot.country) {
        
        if (i <props.currentBot.country.length-1    && props.currentBot.country.length>1) {
        countryString = countryString + props.currentBot.country[i] + ",";
        }
        else {
          countryString = countryString+props.currentBot.country[i] 
        }
      }
      props.currentBot.country = countryString;

     
      //technology 4/12/24
      let technologyString = "";
      for (let i in props.currentBot.technology) {
        if (
          i < props.currentBot.technology.length - 1 &&
          props.currentBot.technology.length > 1
        ) {
          technologyString =
            technologyString + props.currentBot.technology[i] + ",";
        } else {
          technologyString = technologyString + props.currentBot.technology[i];
        }
      }

      props.currentBot.technology = technologyString;
   

      let mcoString = "";
      for (let i in props.currentBot.mco) {
        
        if (i <props.currentBot.mco.length-1    && props.currentBot.mco.length>1) {
        mcoString = mcoString + props.currentBot.mco[i] + ",";
        }
        else {
          mcoString = mcoString+props.currentBot.mco[i] 
        }
      }
      props.currentBot.mco = mcoString;

      let auth = JSON.parse(localStorage.getItem("auth")).data;
     // console.log(auth.accessToken, "accesssssssssss");
    
      delete props.currentBot.botID;
      setLoading(true)
      let authCheck = await JSON.parse(localStorage.getItem("auth")).data;

      let expiryStatus = await props.checkExpiry(authCheck);
      if (expiryStatus) {
        
     
      axios({
        method: "put",
        url: `${endpoint.baseUrl}/bot/editBot`,
        data: {
          botID: BotId,

          botUpdateFields: { ...props.currentBot },
        },
        headers: {
          Authorization: `${auth.accessToken}|${auth.email}`,
        },
      }).then((resp) => {
        if(resp.data.code == 200){
          setLoading(false)
          setSuccessModal(true)
        }
        else if (resp.data.code == 403) {
          setLoading(false)
          props.sessionTimeOutCheck(true)
        }
      });
    }
    else {
      setLoading(false)
      props.sessionTimeOutCheck(true)
    }
    }
  }, [props.currentBot]);

  return (
    <div className={styles.mainContainer}>
      <div className={styles.stepperContainer}>

        { Loading ? <Loader/> : null }
        {successModal ? (
          <SuccessModal
            setSuccessModal={() => {router.push("/botStore")}}
            title={"Edit Bot"}
            parent={"createBot"}
            message={`Bot with BOT ID ${botKiID} has been updated`}
          />
        ) : null}


       
{businessOwnerModal ? (
          <BusinessownerModalComp
            setSuccessModal={setBusinessOwnerModal}
            title={"User Access Mapping"}
            message={"Business owner already exist with another user type"}
            // setMessage={setMessage}
            fail={true}
            // setFail={setFail}
          />
        ) : null}

        <CreateStepper pageNumber={pageNumber} editBot={true} />
      </div>
      {botPages[1] == true && renderFirstBot ? (
        <>
          <div className={botStyles.botContainer}>
            <CreateBot
              nextBot={nextBot}
              data={firstPage.field_bot_form_steps}
              pageNum={1}
              saveInfoToRedux={saveInfoToRedux}
              savedState={props.currentBot}
              formType="editBot"
              setBusinessOwnerModal={setBusinessOwnerModal}
            />
          </div>
        </>
      ) : null}
      {botPages[2] == true ? (
        <CreateBot
          nextBot={nextBot}
          data={secondPage.field_bot_form_steps}
          pageNum={2}
          saveInfoToRedux={saveInfoToRedux}
          savedState={props.currentBot}
          formType="editBot"
        />
      ) : null}
      {botPages[3] == true ? (
        <CreateBot
          nextBot={nextBot}
          data={thirdPage.field_bot_form_steps}
          pageNum={3}
          saveInfoToRedux={saveInfoToRedux}
          savedState={props.currentBot}
          formType="editBot"
        />
      ) : null}
      {botPages[4] == true ? (
        <CreateBot
          allDone={allDone}
          nextBot={nextBot}
          data={fourthPage.field_bot_form_steps}
          pageNum={4}
          saveInfoToRedux={saveInfoToRedux}
          savedState={props.currentBot}
          formType="editBot"
        />
      ) : null}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    currentBot: state.storeBot.currentBot,
    editedCurrentBot: state.storeBot.editedCurrentBot,
  };
};


function mapDispatchToProps(dispatch) {
  return {
    sessionTimeOutCheck: bindActionCreators(sessionTimeOutCheck, dispatch),
    checkExpiry: bindActionCreators(checkExpiry, dispatch),
  };
}


// export default index;
export default connect(mapStateToProps, mapDispatchToProps)(index);
